import { useContext } from 'react';
import PortalIdParser from 'PortalIdParser';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
import { ApprovalContext } from '../context/approvalContext';
// `settingsTab` only applies to the approvals settings page; quotes and deals
// link to their own settings, which have no such tabs. `teamApprovers` only
// deep-links quotes, to its team approvers side panel.
export const useApprovalSettingsUrl = (settingsTab = 'approvers', {
  teamApprovers = false
} = {}) => {
  const entity = useContext(ApprovalContext);
  const portalId = PortalIdParser.get();
  switch (entity === null || entity === void 0 ? void 0 : entity.meta.approvalType) {
    case 'QUOTE':
      return `/settings/${portalId}/sales/quotes/approvals${teamApprovers ? '?sidePanel=teamApprovers' : ''}`;
    case 'DEAL':
      return `/pipelines-settings/${portalId}/object/0-3/default/governance?panel=approvalRule`;
    default:
      {
        const settingsUrl = `/settings/${portalId}/approvals`;
        if (!entity) {
          return settingsUrl;
        }
        const params = new URLSearchParams({
          objectTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[entity.meta.approvalType],
          action: entity.meta.approvalAction,
          tab: settingsTab
        });
        return `${settingsUrl}?${params.toString()}`;
      }
  }
};